import React from 'react'
import imgone from '../assets/img-1.png' 
import imgtwo from '../assets/img-2.png' 
import imgthree from '../assets/img-3.png' 
import divi from '../assets/divi.svg' 
 
const Howit = () => {
  return (
    <>
        <div className='howit-main  '>
            <div className='howit-wrap'>

         <div className='md:w-[20%] ml-11 -mt-20  dots-main hidden md:block lg:block'>
         <div className='flex my-2 '>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex my-3 ml-10 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-1'>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
           <div className='flex my-6 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-2 ml-11'>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex my-8'>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
         
         </div>


            <center className=' md:-mt-20 '>
                <h1 className='text-center  font-Open text-[24px] md:text-[24px] text-[#272C34] font-semibold '>How it Works</h1>
                <img src={divi} alt='divider' className='-mt-9' />
                 
                </center>

 
                   

                <div className=' '>
        <div>
        <div class="container mx-auto">
            
         <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-2'>
             <div className=' pl-9  rounded'>
               
             <h1 className='text-[#272C34] text-[36px] py-2 font-bold  font-Outfit    '>Lorem Ipsum  </h1>
                 <h1 className='text-blue-400   text-[36px] font-bold  font-Outfit    '>Ipsum</h1>
                 <h1 className='text-[#272C34] py-2 text-[36px] font-bold  font-Outfit    '>dolor sit consectetur</h1>
             </div>
             

             <div className=' w-[80%] ml-[10%]  md:w-[50%]  md:ml-[31%] '>
             <span className='h-10 w-10 bg-gray-100 rounded-full pl-4 pt-2 absolute font-bold  mt-6 md:ml-[1rem] ml-[2rem]'>1</span>   
                <img src={imgone} alt='img 1' className='w-full' />
                <h4 className=''> </h4>
                <p className=' leading-5 md:text-left text-justify text-[12px] text-[#272C34] py-4 md:ml-4'>
                <span  className='text-[14px] py-2 font-bold'>Search a nearby padel court</span>
               <br/>  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Etiam cursus, sapien vitae interdum congue, orci tellus 
              condimentum enim, eu venenatis diam ante nec lorem. Nullam ex nisl, 
              tincidunt quis condimentum quis,</p>
             </div>
          </div>

          <div className='grid grid-cols-1 md:-mt-[16%] gap-1 md:grid-cols-3 lg:grid-3'>
             <div className='  m-5 mx-auto rounded'>
             <div className='ml-11'>
             <span className='h-10 w-10 bg-gray-100 rounded-full pl-4 pt-2 absolute font-bold  mt-6 md:ml-[7rem] ml-[2rem]'>3</span>
             <img src={imgtwo} alt='img 1' className='md:w-[80%] w-[90%]   md:ml-[6rem]' />
             </div>
             <p className='leading-5 md:text-left text-justify text-[12px] text-[#272C34] md:px-0 px-5 md:ml-[8rem] ml-6 py-4 md:ml-[8rem]'>
             <span  className='text-[14px] py-2 font-bold'>Confirm payment to play anytime</span>
               <br/>
             Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Etiam cursus, sapien vitae interdum congue, orci tellus 
              condimentum enim, eu venenatis diam ante nec lorem. Nullam ex nisl, 
              tincidunt quis condimentum quis,</p>  
             </div>
             

             <div className='  m-5 rounded'>
             <span className='h-10 w-10 bg-gray-100 rounded-full pl-4 pt-2 absolute font-bold  mt-6 md:ml-[2rem] ml-[2rem]'>2</span>
             <img src={imgthree} alt='img 1' className='md:w-full w-[90%] mx-auto md:ml-2 '/>
             <p className='leading-5 md:text-left text-justify text-[12px] text-[#272C34] md:px-0 px-3 py-4 md:ml-4'>
             <span  className='text-[14px] py-2 font-bold'>Book the court</span>
               <br/>
             Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Etiam cursus, sapien vitae interdum congue, orci tellus 
              condimentum enim, eu venenatis diam ante nec lorem. Nullam ex nisl, 
              tincidunt quis condimentum quis,</p>
             </div>

 

         </div>


        </div>

        </div>
        </div>




            </div>
        </div>
    </>
  )
}

export default Howit